import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Box, Button } from "samba-ui";
import { updateFeed } from "../../../../actions/feed";
import IncludedContent from "../../../../components/Common/CreateFeedModal/IncludedContent";
import LoadingSpinner from "../../../../components/Common/LoadingSpinner";

const filterToContentMap = {
  brand: "included_brands",
  parent_name: "included_parents",
  advertiser_name: "included_advertisers",
  product_name: "included_products"
};

const KantarFilterExpression = ({ feed, updateFeed }) => {
  const expression = feed.kantar_filter_expression;
  const [includeAllBrands, setIncludeAllBrands] = useState(false);
  const [_feed, _setFeed] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const hasFilter = expression && !expression.brand_blacklist;
    setIncludeAllBrands(!hasFilter);
    if (hasFilter) {
      Object.keys(filterToContentMap).forEach(key => {
        if (feed["kantar_filter_expression"][key]) {
          feed[filterToContentMap[key]] = feed["kantar_filter_expression"][
            key
          ].map(v => ({
            value: null,
            label: v
          }));
        }
      });
    }
    _setFeed({ ...feed });
  }, [expression]);

  const onUpdateClick = async () => {
    setLoading(true);
    let kantar_filter_expression = null;

    if (includeAllBrands) {
      kantar_filter_expression = {
        brand_blacklist: ["Unknown Brand"]
      };
    } else {
      const {
        included_brands,
        included_parents,
        included_products,
        included_advertisers
      } = _feed;

      // Otherwise, convert the array of brands to an array of names
      let brand = included_brands
        ? included_brands
          .map(brand => brand.label)
          .sort((a, b) => a.localeCompare(b))
        : [];
      let parent_name = included_parents
        ? included_parents
          .map(parent => parent.label)
          .sort((a, b) => a.localeCompare(b))
        : [];
      let advertiser_name = included_advertisers
        ? included_advertisers
          .map(advertiser => advertiser.label)
          .sort((a, b) => a.localeCompare(b))
        : [];
      let product_name = included_products
        ? included_products
          .map(product => product.label)
          .sort((a, b) => a.localeCompare(b))
        : [];
      if (brand.length) {
        kantar_filter_expression = {
          ...kantar_filter_expression,
          brand
        };
      }
      if (parent_name.length) {
        kantar_filter_expression = {
          ...kantar_filter_expression,
          parent_name
        };
      }
      if (advertiser_name.length) {
        kantar_filter_expression = {
          ...kantar_filter_expression,
          advertiser_name
        };
      }
      if (product_name.length) {
        kantar_filter_expression = {
          ...kantar_filter_expression,
          product_name
        };
      }
    }

    await updateFeed(feed.id, { kantar_filter_expression });
    setLoading(false);
  };

  const onChangeFeed = (field, value) => {
    const updatedFeed = { ..._feed };
    updatedFeed[field] = value;
    _setFeed(updatedFeed);
  };

  return (
    <Box>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Box>
          <IncludedContent
            feed={_feed}
            onChangeFeed={onChangeFeed}
            includeAllBrands={includeAllBrands}
            onChangeBrandsSelection={(includeAllBrands) => {
              setIncludeAllBrands(includeAllBrands)
            }}
          />

          <Button onClick={onUpdateClick} style={{ float: "right" }}>
            Update
          </Button>
        </Box>
      )}
    </Box>
  );
};

KantarFilterExpression.propTypes = {
  feed: PropTypes.object,
  updateFeed: PropTypes.func
};
export default connect(
  null,
  { updateFeed }
)(KantarFilterExpression);
